import { render, staticRenderFns } from "./EditCashRegisterReceiptSettingsInline.vue?vue&type=template&id=7c5f4314&scoped=true&"
import script from "./EditCashRegisterReceiptSettingsInline.vue?vue&type=script&lang=js&"
export * from "./EditCashRegisterReceiptSettingsInline.vue?vue&type=script&lang=js&"
import style0 from "./EditCashRegisterReceiptSettingsInline.vue?vue&type=style&index=0&id=7c5f4314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5f4314",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VForm,VIcon,VRow,VTextField,VTextarea})
